import {isAndroid, isIOS, osName} from 'react-device-detect';
    
export function onWebviewClose(){
    try {
        if(isAndroid){
            window.Android.onCloseNotice();
        }else if(isIOS){
            window.webkit.messageHandlers.onCloseNotice.postMessage("");
        }else if(osName === 'iOS' || osName === 'Mac OS'){
            window.webkit.messageHandlers.onCloseNotice.postMessage("");
        }else{
            window.Android.onCloseNotice();
        }
    } catch (error) {
        
    }
}
export function onBackNotice(){
    // console.log('onBackNotice');
}
export default onWebviewClose;